module.exports = __webpack_public_path__ + "d226c9b80523eed56a031e35ed002756.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/national-state-parks/Yosemite3.jpg
// module id = 3542
// module chunks = 0